<template>
  <div>
    <div class="my">
      <img src="../../assets/img/Group 2981.png" alt />
      <div class="my-bottom">
        <van-button round block type="primary" @click="handleOpenApp">打开APP</van-button>
      </div>
    </div>
    <van-overlay :show="show" @click="show = false">
      <img src="../../assets/img/Group 2982.png" alt style="position: absolute; right: 0" />
    </van-overlay>
  </div>
</template>

<script>
import { getNewAppVersion } from "@/api/onternetPolitics/index.js";
import { filePerviewPath } from "@/api/ActivitySolicitation/index.js";
import { weChatSharing } from "@/utils/app.js";
export default {
  data() {
    return {
      show: false,
      isWeixin: false,
      isEquipment: "",
      downloadUrl: "", //下载路径
      link: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    //  修复iOS版微信HTML5 History兼容性问题   location.pathname是url
    if (to.path !== location.pathname) {
      console.log("检测完成")
      // 此处不可使用location.replace
      location.assign(to.fullPath); //to.fullPath指的是路由
    } else {
      next();
    }
  },

  created() {
    weChatSharing();
    // localStorage.setItem("webTenId", this.$route.query.webTenId);
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    if (isWeixin) {
      console.log("你来到微信浏览器啦!");
      this.isWeixin = true;
    } else {
      console.log("可惜了你不在!");
      this.isWeixin = false;
    }
    // 访问来源判断
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      this.isEquipment = "isAndroid";
    } else if (isiOS) {
      this.isEquipment = "ios";
    } else {
      this.isEquipment = "noMobileDevices";
      console.log("noMobileDevices");
    }
  },
  mounted() {
    document.title = "我的问政";
    this.getDownload();
  },
  methods: {
    // 下面的代码，楼主楼主是在Vue2中使用的，如果语言不通，根据自己所写的语言稍微改下即可。
    handleOpenApp() {
      if (this.isWeixin) {
        this.show = true;
      } else {
        if (this.isEquipment == "noMobileDevices") {
          alert("请在手机上打开");
          return false;
        } else if (this.isEquipment == "isAndroid") {
          window.location.href = this.link;
          window.setTimeout(() => {
            //下载分享页
            window.location.href = this.downloadUrl;
          }, 2500);
        } else if (this.isEquipment == "ios") {
          console.log("sdsf", this.link);
          window.location.href = this.link;
          var loadDateTime = new Date();
          window.setTimeout(function() {
            var timeOutDateTime = new Date();
            if (timeOutDateTime - loadDateTime < 5000) {
              //下载分享页
              window.location.href = this.downloadUrl;
            } else {
              window.close();
            }
          }, 500);
        }

        //   window.location.href = this.downloadUrl;
      }
    },
    //获取最新的下载地址
    getDownload() {
      getNewAppVersion({
        webProType: 0,
        webDevType: this.isEquipment == "ios" ? 0 : 1
      }).then(({ data }) => {
        if (data.code == 200) {
          console.log(data.data);
          if (data.data.webDevType == 1) {
            this.downloadUrl = filePerviewPath({
              id: data.data.fileObjId,
              type: "resource"
            });

            console.log(this.downloadUrl);
          } else {
            this.downloadUrl = data.data.webAppStore;
            console.log(this.downloadUrl);
          }
          let appScheme = data.data.urlScheme; // 1文章,2 视频, 3  电视直播, 4 活动直播, 5 栏目详情, 6 图片详情, 7 爆料详情
          this.link = `${appScheme}://askingPoliticsHome`;
          console.log("link", this.link);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.my {
  padding-top: 0.96rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    margin-bottom: 1.38rem;
    width: 92%;
  }
  .my-bottom {
    width: 74%;
    /deep/.van-button--primary {
      background: linear-gradient(
        90deg,
        #f96443 0%,
        rgba(239, 109, 53, 0.8) 100%
      ) !important;
      border: none;
    }
  }
}
</style>